import React from 'react';
import { useRecoilValue } from 'recoil';
import { otherBankInfoState } from '../../../../../data/estimate/common/otherBank/info/selector';
import useUpdateInfo from '../../../../../hooks/estimate/common/useUpdateInfo';
import { otherBankPrincipalTypeInfoState } from '../../../../../data/estimate/common/otherBank/info/atom';
import styled from '@emotion/styled';

const Radio = styled.input`
  width: 10px;
  height: 10px;
`;

/**
 *  타금융사 할부조건 가용금액 라디오 컴포넌트
 *  */
function OtherBankPaymentTypeRadio(): JSX.Element {
  // selected
  const principalType: string = useRecoilValue(
    otherBankInfoState({ name: 'otherBankPrincipalType' })
  );

  // function
  const update = useUpdateInfo(otherBankPrincipalTypeInfoState);
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked: boolean = e.target.checked;
    checked && update('paymentType');
  };
  return (
    <Radio
      type='radio'
      name='otherBank-principalType'
      onChange={onChange}
      checked={principalType === 'paymentType'}
    />
  );
}

export default OtherBankPaymentTypeRadio;
